<template>
	<form id="add-site-form" novalidate class="needs-validation" :class="{'was-validated':hasError}" v-on:submit.prevent="saveForm">

		<error :error="error"></error>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="site-name">Name</label>
					<input id="site-name" class="form-control" placeholder="" v-model="nameValue"/>
				</div>
			</div>
			<div class="col-sm-6">
			</div>
		</div>

		<div class="clearfix mt-1 mb-3">
			<div class="float-left ml-3">
				
			</div>
			<div class="float-right mr-3">
				<button type="submit" class="btn btn-outline-primary px-3">Add</button>
				<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>
			</div>
		</div>

	</form>
</template>

<script>
	import Error from './Error'

	import api from '../api'
	import store from '../state'
	import router from '../router'

	export default {
		name: 'AddSiteForm',
		components: {Error},
		props: ['site'],
		data() {
			return {
				error: '',
				nameValue: ''
			}
		},
		methods: {
			closeForm() {
				this.$emit('close-add-site');
			},
			async saveForm() {
				
				try
				{
					const newSite = {
						PartitionKey: '' + this.site,
						RowKey: this.nameValue
					};

					const response = await api.post('system/site', newSite);	

					this.closeForm();
				}
				catch(err) {
					this.error = err + ""; //Get the string representation of the error		
				}
			}
		},
		computed: {
			hasError() {
				return false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/AddSiteForm.vue